<select (change)="onSelect($event)" class="form-control" [disabled]="disabled">
  <option value="" disabled selected>{{ placeholder }}</option>
  @for (option of question.options; track option) {
    <option
      [value]="question.getterKey ? getIdKey(option,question) : option.id || option.configKey">
      {{ question.getterValue ? getValue(option,question.getterValue) : option.value || option.configValue }}
    </option>
  }
</select>

@if (!items || items.length === 0) {
  <span class="help-block">
    No {{ name || 'values' }} attached...
  </span>
}

@if (items) {
  <div>
    @for (item of items; track item; let i = $index) {
      <span class="tag label label-info">
        @if (!showItemIndex) {
          <span>{{ optionsLookup[item] }}</span>
        }
        @if (showItemIndex) {
          <span>{{ (i + 1) + "." + " " + optionsLookup[item] }}</span>
        }
        <i (click)="onRemove(item)" class="fa fa-close"></i>
      </span>
    }
  </div>
}